var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperandioFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 161.56 32.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "GradientFill_1",
    "data-name": "GradientFill 1",
    cx: 15.04,
    cy: 9.42,
    r: 7.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f78f28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2",
    "data-name": "GradientFill 2",
    x1: 15.06,
    y1: 9.08,
    x2: 20.62,
    y2: 15.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f78f28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f26341"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "GradientFill_1-2",
    cx: 9.55,
    cy: 10.03,
    r: 7.94,
    xlinkHref: "#GradientFill_1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2-2",
    x1: 12.11,
    y1: 19.72,
    x2: 15.14,
    y2: 22.28,
    xlinkHref: "#GradientFill_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2-3",
    x1: 12.36,
    y1: 23.63,
    x2: 17.68,
    y2: 29.48,
    xlinkHref: "#GradientFill_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "GradientFill_2-4",
    x1: 6.15,
    y1: 21.08,
    x2: 7.77,
    y2: 22.66,
    xlinkHref: "#GradientFill_2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.4,8.14v2a8.44,8.44,0,0,1,2.67-1.83,7.77,7.77,0,0,1,3.08-.62,7.93,7.93,0,0,1,6,2.69,9.72,9.72,0,0,1,2.49,6.89A9.52,9.52,0,0,1,40.11,24,8.1,8.1,0,0,1,34,26.77a7.63,7.63,0,0,1-2.92-.56,8.81,8.81,0,0,1-2.69-1.83V33H23.85V8.14Zm4.78,3.73a4.73,4.73,0,0,0-3.56,1.47,5.28,5.28,0,0,0-1.42,3.84,5.42,5.42,0,0,0,1.42,3.91,4.9,4.9,0,0,0,7.08,0,5.43,5.43,0,0,0,1.43-3.87,5.34,5.34,0,0,0-1.41-3.83,4.62,4.62,0,0,0-3.54-1.5Zm30.11,6.65H48.66a4.9,4.9,0,0,0,1.69,3.09,5.23,5.23,0,0,0,3.49,1.15A6,6,0,0,0,58.22,21L62,22.77a9.07,9.07,0,0,1-3.42,3,10.77,10.77,0,0,1-4.75,1,9.37,9.37,0,0,1-6.95-2.7,9.14,9.14,0,0,1-2.68-6.74,9.46,9.46,0,0,1,2.68-6.89,9,9,0,0,1,6.72-2.75,9.37,9.37,0,0,1,7,2.74,9.82,9.82,0,0,1,2.69,7.22l0,.87ZM58.76,15A4.51,4.51,0,0,0,57,12.53a5.28,5.28,0,0,0-3.1-.93,5.56,5.56,0,0,0-3.35,1.05A5.86,5.86,0,0,0,48.86,15ZM64.6,8.14h3.93v2.31a4.88,4.88,0,0,1,1.68-2,4,4,0,0,1,2.29-.71,4.26,4.26,0,0,1,1.85.47L72.94,12.1a3.06,3.06,0,0,0-1.31-.4A2.07,2.07,0,0,0,69.86,13c-.49.87-.73,2.57-.73,5.1l0,.89v7.33H64.6V8.14Zm24.11,0h4.55V26.32H88.71V24.39A9,9,0,0,1,86,26.21a7.54,7.54,0,0,1-2.91.56A8.12,8.12,0,0,1,77,24a9.47,9.47,0,0,1-2.57-6.77,9.72,9.72,0,0,1,2.49-6.89,8,8,0,0,1,6-2.69,7.74,7.74,0,0,1,3.08.62,8.4,8.4,0,0,1,2.66,1.83v-2Zm-4.8,3.73a4.6,4.6,0,0,0-3.52,1.5A5.34,5.34,0,0,0,79,17.2a5.43,5.43,0,0,0,1.43,3.87,4.63,4.63,0,0,0,3.51,1.52,4.69,4.69,0,0,0,3.57-1.5,5.42,5.42,0,0,0,1.42-3.91,5.28,5.28,0,0,0-1.42-3.84,4.76,4.76,0,0,0-3.58-1.47ZM96.5,8.14h4.55V10a11,11,0,0,1,2.81-1.81,7,7,0,0,1,2.58-.51A6.26,6.26,0,0,1,111,9.58a6.5,6.5,0,0,1,1.58,4.74v12H108.1V18.37a19.65,19.65,0,0,0-.29-4.31,2.72,2.72,0,0,0-2.8-2.19,3.35,3.35,0,0,0-2.38.93,4.89,4.89,0,0,0-1.38,2.55,21.06,21.06,0,0,0-.2,3.69v7.28H96.5V8.14Zm32.65-7h4.55v25.2h-4.55V24.39a9,9,0,0,1-2.69,1.82,7.54,7.54,0,0,1-2.91.56A8.12,8.12,0,0,1,117.44,24a9.47,9.47,0,0,1-2.57-6.77,9.72,9.72,0,0,1,2.49-6.89,8,8,0,0,1,6-2.69,7.74,7.74,0,0,1,3.08.62,8.55,8.55,0,0,1,2.66,1.84v-9Zm-4.8,10.75a4.62,4.62,0,0,0-3.53,1.5,5.38,5.38,0,0,0-1.4,3.83,5.38,5.38,0,0,0,1.43,3.87,4.63,4.63,0,0,0,3.51,1.52,4.69,4.69,0,0,0,3.57-1.5,5.42,5.42,0,0,0,1.42-3.91,5.28,5.28,0,0,0-1.42-3.84,4.76,4.76,0,0,0-3.58-1.47Zm12.11-3.73H141V26.32h-4.55V8.14Zm15.88-.45A9.62,9.62,0,0,1,157.18,9a9.21,9.21,0,0,1,3.55,3.48A9.32,9.32,0,0,1,162,17.21a9.51,9.51,0,0,1-1.28,4.8,9.24,9.24,0,0,1-3.49,3.5,9.69,9.69,0,0,1-4.87,1.26A9.09,9.09,0,0,1,145.67,24a9.19,9.19,0,0,1-2.78-6.74A9.16,9.16,0,0,1,146,10.16a9.18,9.18,0,0,1,6.31-2.47Zm.07,4.29a4.72,4.72,0,0,0-3.55,1.47,5.24,5.24,0,0,0-1.41,3.78,5.3,5.3,0,0,0,1.4,3.82,4.67,4.67,0,0,0,3.54,1.47A4.75,4.75,0,0,0,156,21a5.32,5.32,0,0,0,1.42-3.81,5.29,5.29,0,0,0-1.4-3.8A4.73,4.73,0,0,0,152.41,12Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fill: "#18122f",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.81,5.71a2.81,2.81,0,0,0,.85-2.07,2.85,2.85,0,0,0-.86-2.1,2.83,2.83,0,0,0-2.06-.87,2.8,2.8,0,0,0-2.05.86,2.75,2.75,0,0,0-.85,2,2.88,2.88,0,0,0,.86,2.12,2.8,2.8,0,0,0,2.07.87A2.75,2.75,0,0,0,140.81,5.71Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fill: "#fb5b3a",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.51,10.8a1.73,1.73,0,0,0-.25-.3,9.52,9.52,0,0,0-6.63-2.78h-.12a9.59,9.59,0,0,0-3.63.72l-.57.26a5.68,5.68,0,0,1,1,1.63,5.66,5.66,0,0,1,.44,2.18c0,.07,0,.15,0,.22a5.45,5.45,0,0,1,.76-.39,5.13,5.13,0,0,1,2-.4h0a5.23,5.23,0,0,1,3.66,1.55,5.12,5.12,0,0,1,1.15,1.7,5.35,5.35,0,0,1,0,4.06,5.28,5.28,0,0,1-4.88,3.25h0a5.18,5.18,0,0,1-2-.4,5.21,5.21,0,0,1-3.25-4.85,5.57,5.57,0,0,1-1,.55,5.75,5.75,0,0,1-2.19.44H4a6.53,6.53,0,0,1-.9-.09,9.6,9.6,0,0,0,2.45,5.49,1.81,1.81,0,0,0,.25.3,9.52,9.52,0,0,0,6.64,2.78h.11A9.59,9.59,0,0,0,16.17,26a9.4,9.4,0,0,0,3.09-2.06,1.42,1.42,0,0,0,.25-.3,9.52,9.52,0,0,0,0-12.84Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fill: "#f63b3b",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32,8.7a9.61,9.61,0,0,1,3.3-.95,9.57,9.57,0,0,1,7,2.12,2.11,2.11,0,0,1-2.69,3.26,25.08,25.08,0,0,0-7-3.67A7.09,7.09,0,0,0,8.32,8.7Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,10.31l0,.06a2.11,2.11,0,0,1-3,.29,23.47,23.47,0,0,0-4.88-2.84l.53-.07a9.57,9.57,0,0,1,7,2.12A2.07,2.07,0,0,1,19,10.31Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,12.51a23.75,23.75,0,0,0-3.79-1.8,5.62,5.62,0,0,0-1.78-.25.69.69,0,0,0-.05-.13,5.94,5.94,0,0,0-.45-.87A25.71,25.71,0,0,1,15.67,13l-.06,0A4.46,4.46,0,0,0,15,12.51Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_1-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.45,22.07c-1.52-.23-4.22-.33-4.55,2,.26.25.53.49.81.71A9.46,9.46,0,0,0,10,26.42a9.66,9.66,0,0,0,3.69.28,9.53,9.53,0,0,0,3.53-1.15A9.34,9.34,0,0,0,19.31,24a10.4,10.4,0,0,0,2.63-5.52c-.05.15,0,.29-.06.42-.9,3.2-5.19,3.79-8.56,3.58l-.14,0A5.3,5.3,0,0,1,10.45,22.07Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_2-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,25a9.44,9.44,0,0,0,3,1.45,9.66,9.66,0,0,0,3.69.28,9.53,9.53,0,0,0,3.53-1.15,9.38,9.38,0,0,0,2-1.54,10.74,10.74,0,0,1-2.37.51c-2.94.33-6.24-.69-8.12-.41A2.69,2.69,0,0,0,7,25Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_2-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18,20.19c-2.71-.21-3.51,1-3.71,2A9.84,9.84,0,0,0,5.9,24c.33-2.29,3-2.19,4.55-2A5.36,5.36,0,0,1,8.18,20.19Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fillRule: "evenodd",
      fill: "url(#GradientFill_2-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71,10.07,6.62,10a3.52,3.52,0,0,0-1.18-.78,3.83,3.83,0,0,0-1.35-.28H4A3.65,3.65,0,0,0,1.49,10l-.1.12a3.41,3.41,0,0,0-.67,1.06,3.54,3.54,0,0,0,0,2.76A3.41,3.41,0,0,0,1.39,15l.1.12a3.58,3.58,0,0,0,1.17.78A3.62,3.62,0,0,0,4,16.13h0a3.58,3.58,0,0,0,1.38-.28,3.52,3.52,0,0,0,1.18-.78L6.71,15a3.63,3.63,0,0,0,.68-1.06,3.66,3.66,0,0,0,0-2.76A3.63,3.63,0,0,0,6.71,10.07Z",
    transform: "translate(-0.44 -0.67)",
    style: {
      fill: "#fd9317",
      fillRule: "evenodd"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperandioFull);
export default __webpack_public_path__ + "static/media/operandio-full.6515b58832aee651fe51188246f8019b.svg";
export { ForwardRef as ReactComponent };